import PropTypes from 'prop-types';
import get from 'lodash/get';
import keys from 'lodash/keys';
import omit from 'lodash/omit';
import classNames from 'classnames';
import React, {Component} from 'react';
import css from './css.css';
import { Filter } from "~/ui/Fields/VariadicField/VariadicField";
import TargetGrid from "~/components/TargetGrid/TargetGrid";
import { extractSpacingProps } from '~/native-ui';
// import { AddConstraint } from './AddConstraint';
import { CreateFilter } from './CreateFilter';

export default class GroupedFields extends Component {
    static propTypes = {
        className: PropTypes.string,
        type: PropTypes.string.isRequired,
        captions: PropTypes.object,
        fieldNames: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.object])).isRequired,
        modelId: PropTypes.string.isRequired,
    };

    static defaultProps = {

    };

    getRows = () => {
        return [
            { name: 'fields', ...omit(this.props, keys(this.propTypes)) },
            { name: 'add_constraint', xs: 1 },
        ];
    };

    getElements = () => {
        return {
            add_constraint: [{
                name: "add_constraint",
                element: (<CreateFilter modelId={this.props.modelId} />),
                // element: (<AddConstraint modelId={this.props.modelId} />),
            }],
            fields: this.props.fieldNames.map((metaOrName, index) => {
                let name = get(metaOrName, 'name', metaOrName),
                    group = get(metaOrName, 'group', undefined);

                return {
                    name,
                    group,
                    element: (<Filter index={ index } type={this.props.type} name={name} modelId={this.props.modelId} />),
                };
            })
        };
    };

    render() {
        const [spacingProps] = extractSpacingProps(this.props);
        return (//aa
            <TargetGrid
                { ...spacingProps }
                rows={this.getRows()}
                elements={this.getElements()} className={classNames(this.props.className, css.fieldGroup)}
            />
        );
    }
}